export const DEFAULT_PORT = 8969;
export const SERVER_IDENTIFIER = 'spotlight-by-sentry';
export const CONTEXT_LINES_ENDPOINT = '/contextlines';
